module.exports = __webpack_public_path__ + "img/ogwhatsapp.419c8703.webp";